import styled from 'styled-components';
import { SvgIcon } from '../SvgIcon';
export const $SvgIcon = styled(SvgIcon) `
  opacity: 0.87;
`;
